<template>
	<div>
		<v-flex class="px-4 mt-3 content-tabs-configuration">
			<v-flex>
				<v-tabs
				slot="extension"
				fixed-tabs
				v-model="tabsModel"
				background-color="transparent">
					<v-tab v-for="(item, index) in tabs" :key="index">
						{{item.name}}
					</v-tab>
				</v-tabs>
			</v-flex>
			<v-tabs-items v-model="tabsModel">
				<v-tab-item>
					<v-card flat>
						<v-card-text>
							<dealers-list />
						</v-card-text>
					</v-card>
				</v-tab-item>
				<v-tab-item>
					<v-card flat>
						<v-card-text>
							<implementers-list />
						</v-card-text>
					</v-card>
				</v-tab-item>
				<v-tab-item>
					<v-card flat>
						<v-card-text>
							<synchronize-companies-list />
						</v-card-text>
					</v-card>
				</v-tab-item>
			</v-tabs-items>
		</v-flex>
		<router-view></router-view>
	</div>
</template>
<script>
import dealersList from '@/components/configuration/dealers-list';
import implementersList from '@/components/configuration/implementers-list';
import synchronizeCompaniesList from '@/components/configuration/synchronize-companies-list';

function created() {
	if (this.$route.name === 'page-config-implementers') {
		this.tabsModel = 1;
	} else if (this.$route.name === 'page-config-dealers') {
		this.tabsModel = 0;
	} else if (this.$route.name === 'page-config-synchronize-companies') {
		this.tabsModel = 2;
	}
}

function tabsModel(value) {
	if (this.$route.meta.primary) {
		if (value === 0) {
			this.goTo('page-config-dealers');
		} else if (value === 1) {
			this.goTo('page-config-implementers');
		} else if (value === 2) {
			this.goTo('page-config-synchronize-companies');
		}
	}
}

function newRoute(value) {
	if (value.name === 'page-config-dealers') {
		this.tabsModel = 0;
	} else if (value.name === 'page-config-implementers') {
		this.tabsModel = 1;
	} else if (value.name === 'page-config-synchronize-companies') {
		this.tabsModel = 2;
	}
}

function data() {
	return {
		tabsModel: null,
		tabs: [
			{
				id: 1,
				name: 'Distribuidores',
			},
			{
				id: 2,
				name: 'Implementadores',
			},
			{
				id: 3,
				name: 'Sincronización de compañías',
			},
		],
	};
}

export default {
	name: 'page-list-configuration',
	data,
	created,
	components: {
		dealersList,
		implementersList,
		synchronizeCompaniesList,
	},
	watch: {
		tabsModel,
		$route: newRoute,
	},
};
</script>


// WEBPACK FOOTER //
// src/pages/configuration/page-list-configuration.vue